import { Routes, Route, Navigate } from "react-router-dom";
import { AuthGate } from "./AuthGate";
import { AdminLayout } from "./components/AdminLayout";
import { ToastProvider } from "./components/Toast";
import OverviewPage from "./pages/overview";
import UsuariosPage from "./pages/usuarios";
import ConsultasPage from "./pages/consultas";
import EmpresasPage from "./pages/empresas";
import PagamentosPage from "./pages/pagamentos";
import CuponsPage from "./pages/cupons";
import DenunciasPage from "./pages/denuncias";
import BackupsPage from "./pages/backups";
import McpPage from "./pages/mcp";
import TecnicoPage from "./pages/tecnico";

export default function App() {
  return (
    <AuthGate>
      <ToastProvider>
        <AdminLayout>
          <Routes>
            <Route path="/" element={<OverviewPage />} />
            <Route path="/usuarios" element={<UsuariosPage />} />
            <Route path="/consultas" element={<ConsultasPage />} />
            <Route path="/empresas" element={<EmpresasPage />} />
            <Route path="/pagamentos" element={<PagamentosPage />} />
            <Route path="/cupons" element={<CuponsPage />} />
            <Route path="/denuncias" element={<DenunciasPage />} />
            <Route path="/backups" element={<BackupsPage />} />
            <Route path="/mcp" element={<McpPage />} />
            <Route path="/tecnico" element={<TecnicoPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AdminLayout>
      </ToastProvider>
    </AuthGate>
  );
}
